/**
 * 金额工具函数 —— 整数美分 ⇄ 美元 互转
 *
 * 设计规范:
 *   1. 后端 / API 入参出参统一为 BigInt 风格的"整数美分"
 *   2. 前端展示统一为美元小数（precision=2）
 *   3. 任何业务代码禁止直接使用 number * 100 / number / 100，必须走以下函数
 */

/** 将"美分整数"安全转换为"美元数字" */
export function centsToDollars(cents: number): number {
  if (!Number.isFinite(cents)) return 0;
  return Math.round(cents) / 100;
}

/** 将"美元数字"安全转换为"美分整数"，避免浮点误差 */
export function dollarsToCents(dollars: number): number {
  if (!Number.isFinite(dollars)) return 0;
  return Math.round(dollars * 100);
}

/**
 * 将"美分整数"格式化为带千分位、$ 前缀的字符串。
 * 例如 1234567 → "$12,345.67"
 */
export function formatMoney(cents: number, currency: 'USD' = 'USD'): string {
  const dollars = centsToDollars(cents);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(dollars);
}
